import { useCallback, useEffect, useState } from "react";
import {
  deleteHistoryApi,
  deleteMessageApi,
  deleteUpdateApi,
  getDeleteStatusApi,
} from "../services/deleteChatService";

export const useDeleteHistory = () => {
  const [isLoading, setLoading] = useState(false);
  const ClearLogs = async (payload) => {
    try {
      await deleteHistoryApi(payload);
      setLoading(true);
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { isLoading, ClearLogs };
};

export const useDeleteChatGet = () => {
  const [loading, setLoading] = useState(true);
  const [deleteData, setDeleteData] = useState([]);

  const fetchDeleteChat = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getDeleteStatusApi();
      // console.log(response.delete_access_control[0], "response");
      setDeleteData(response.delete_access_control[0]);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchDeleteChat();
    }, 500);
    return () => clearTimeout(timer);
  }, [fetchDeleteChat]);

  return { loading, deleteData };
};

export const useDeleteUpdate = () => {
  const [isUpdating, setUpdating] = useState(false);
  const UpdateDel = async (payload) => {
    try {
      await deleteUpdateApi(payload);
      setUpdating(true);
    } catch (error) {
      throw error;
    } finally {
      setUpdating(false);
    }
  };

  return { isUpdating, UpdateDel };
};

export const useDeleteMessage = () => {
  const [isUpdating, setUpdating] = useState(false);
  const deleteMessage = async (messageId, chatUniqueId) => {
    try {
      setUpdating(true);

      await deleteMessageApi(
        `chat_unique_id=${chatUniqueId}&message_id=${messageId}`
      );
    } catch (error) {
      throw error;
    } finally {
      setUpdating(false);
    }
  };

  return { isUpdating, deleteMessage };
};
